
/* eslint-disable vue/no-mutating-props */
// `target` is the orchestrator's shared form-model object, passed by reference
// so this step can fill it in. The orchestrator owns it; we mutate in place.
import { mapGetters } from 'vuex'
// medicareParts / coverageUrgencies / months now live in the Vuex store (single
// source of truth, Salesforce-synced enums). SC_OPTIONS stays here — it maps to
// boolean User flags (hsa / collecting_ssi / moving), not a Salesforce enum.
import { SC_OPTIONS } from '~/data/schedule-v2-config.js'

export default {
    props: {
        target: { type: Object, required: true },
        gate: { type: Boolean, default: false },
        // #679 Phase 2: swap the parts/start-date half for the
        // current-coverage questions (new client booking an AEP plan review).
        planReview: { type: Boolean, default: false },
    },
    data () {
        const y = new Date().getFullYear()
        return {
            scOptions: SC_OPTIONS,
            // Current year + 9 future years.
            coverageYears: Array.from({ length: 10 }, (_, i) => y + i),
            moveByState: false,
            movingLocLabel: '',
            coverageMonth: this.target.effective_date ? new Date(this.target.effective_date).getMonth() + 1 : '',
            coverageYear: this.target.effective_date ? new Date(this.target.effective_date).getFullYear() : '',
        }
    },
    computed: {
        // usStates is the store getter (loaded once via loadUsStates on client init).
        ...mapGetters(['medicareParts', 'coverageUrgencies', 'months', 'usStates', 'postMedicareCoverages']),
        // Carrier/plan-name inputs for the picked coverage — the same fields
        // and labels survey/_uid/quick-aep.vue edits (User columns
        // {supp,pdp,mapd}_{carrier,name}).
        carrierFields () {
            const cov = this.target.current_medicare_coverage
            const fields = []
            if (cov === 'SUPP' || cov === 'SUPP_PDP') {
                fields.push(
                    { key: 'supp_carrier', label: 'Supplement plan carrier (Ex. United)' },
                    { key: 'supp_name', label: 'Supplement plan name (Ex. Plan G/F/N)' },
                )
            }
            if (cov === 'PDP' || cov === 'SUPP_PDP') {
                fields.push(
                    { key: 'pdp_carrier', label: 'Prescription plan carrier (Ex. Wellcare)' },
                    { key: 'pdp_name', label: 'Prescription plan name (Ex. Value Script)' },
                )
            }
            if (cov === 'MAPD') {
                fields.push(
                    { key: 'mapd_carrier', label: 'Advantage plan carrier (Ex. Aetna)' },
                    { key: 'mapd_name', label: 'Advantage plan name (Ex. Explorer PPO)' },
                )
            }
            return fields
        },
    },
    watch: {
        coverageMonth () { this.syncEffectiveDate() },
        coverageYear () { this.syncEffectiveDate() },
    },
    methods: {
        syncEffectiveDate () {
            if (this.coverageMonth && this.coverageYear) {
                this.target.effective_date = `${this.coverageYear}-${String(this.coverageMonth).padStart(2, '0')}-01`
            } else {
                this.target.effective_date = null
            }
        },
        toggleSpecial (id) {
            this.target[id] = !this.target[id]
        },
        async onMovingZip (e) {
            const z = String(e.target.value || '').replace(/\D/g, '').slice(0, 5)
            this.target.moving_zipcode = z
            this.movingLocLabel = ''
            if (z.length !== 5) return
            try {
                const resp = await this.$api.getCountiesForZip(z)
                if (resp?.counties?.length) {
                    const c = resp.counties[0]
                    this.target.moving_state = c.state
                    this.movingLocLabel = `${c.city || ''}${c.city ? ', ' : ''}${c.state}`.trim()
                }
            } catch (e) { /* silent */ }
        },
    },
}
